// extracted by mini-css-extract-plugin
export default {"originalTag":"TagList_originalTag__9y-d6","tagContainer":"TagList_tagContainer__+1iYr","channelTag":"TagList_channelTag__Flw0Q"};